/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Auth/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import No from './No/index'
import NotFound from './NotFound/index'
import React from 'react'
import SignIn from './SignIn/index'



/** @type {import('Simple/types.js').View} */
export default function Auth({
  children,
  viewPath = "/App/Auth"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let flowShortcutsIdValueData = fromData.useDataValue({ viewPath,
context: 'flow_shortcuts',
path: 'id',
})
let aggregateData = fromHelpers.getView(flowShortcutsIdValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: aggregateData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'SignIn'}>
<SignIn
  viewPath={`${viewPath}/SignIn`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'NotFound'}>
<NotFound
  viewPath={`${viewPath}/NotFound`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}